import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ shadows, shape }: Theme) => ({
  autoComplete: {
    width: '100%',
  },
  autoCompleteInputRoot: {},
  autoCompleteEndAdornment: {
    marginRight: 5,
  },
  autoCompleteOption: {
    fontSize: 14,
    borderRadius: 4,
    marginLeft: 5,
    marginRight: 5,
  },
  autoCompleteListbox: {
    boxShadow: shadows[7],
    borderRadius: shape.borderRadius,
  },
  autoCompletePaper: {
    boxShadow: 'none',
    overflow: 'visible',
  },
  autoCompletePopper: {
    top: 'calc(100% - 7px)',
  },
}));
